import React, { useEffect } from 'react'
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom'

import CustomCard from '../../utils/components/CustomCard';
import { Box, Divider, Typography, Grid, Container, Button } from '@mui/material';

function IndexCatalogos() {

    const auth = useSelector((state) => state.auth);
    let navigate = useNavigate();

    useEffect(() => {
        document.title = 'Inventario';
    }, [])

    return (

        <Container maxWidth='xl' style={{ marginTop: '10px' }}>
            <Box className='text-center' >
                <Typography variant='h4' style={{ fontWeight: 700 }}>Catálogo de Productos</Typography>
            </Box>
            <Button size='small' variant='outlined' onClick={() => navigate('/inventario')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>
            <Divider variant="middle" className='my-3' />
            <Grid container spacing={3}>
                {cards.map((card, i) => {
                    if (card.auth.includes(auth.user.rol)) {
                        return (
                            <Grid item key={i} xs={12} sm={6} md={4}>
                                <CustomCard
                                    title={card.title}
                                    to={card.to}
                                    button={card.button}
                                    cardIco={card.cardIco}
                                    text={card.text}
                                    color={'primary.main'}
                                    btnColor={'primary'}
                                />
                            </Grid>
                        )
                    }
                    return null;
                })}
            </Grid>
            <br></br>
        </Container>
    )
}

const cards = [
    {
        title: "Catálogo de Teclados y Membranas",
        text: "Consulta el catálogo de teclados y membranas",
        button: "Teclados y Membranas",
        cardIco: "fad fa-file fa-3x",
        to: "/catalogos/teclados",
        auth: ['Admin']
    },
    {
        title: "Catálogo de Impresión 3D",
        text: "Consulta el catálogo de piezas y refacciones impresas en 3D",
        button: "Impresión 3D",
        cardIco: "fad fa-cubes fa-3x",
        to: "/catalogos/impresion3d",
        auth: ['Admin']
    }
]

export default IndexCatalogos;